// @ts-nocheck until we determine why customer-ui errors on this file in webpack-build
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { WebAuth, } from 'auth0-js';
import jwt_decode from 'jwt-decode';
import * as CryptoJS from 'crypto-js';
export const EXPIRES_AT_COOKIE = 'expiresIn';
export const LOGIN_HINT_COOKIE = 'loginHint';
export const AUTH0_SESSION_ACTIVE = 'auth0SessionActive';
export const CUSTOMER_ID_COOKIE = 'customerId';
export class TokenManager {
    static generateRandomString() {
        //uses Cryptographically secure pseudorandom number generator
        return CryptoJS.lib.WordArray.random(64).toString(CryptoJS.enc.Hex);
    }
    static getCookie(name) {
        const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
        return match ? match[2] : null;
    }
    static setCookie(key, value) {
        const cookieValue = `${key}=${value};path=/`
            .replace(/\n/g, '')
            .replace(/\r/g, '');
        document.cookie = cookieValue;
    }
    static isValidId(str) {
        if (str != null && new RegExp(`^[A-Za-z0-9-]*$`).test(str)) {
            return true;
        }
        throw Error('Request Parameter Error');
    }
    authProvider;
    providerInstance;
    profile = null;
    clientId;
    schedulerId;
    accessToken = '';
    domain;
    /**
     * Creates an instance of Auth0Token manager with an auth provider
     * @param webAuth
     */
    constructor(authProvider) {
        this.authProvider = authProvider;
    }
    /**
     * Initializes the AuthProvider with AuthOptions.  ResponseType
     * default to 'openid profile' and scope defaults to 'token id_token'.
     * @param authOptions
     */
    async init(authOptions) {
        this.providerInstance = new this.authProvider({
            responseType: 'token id_token',
            responseMode: 'form_post',
            scope: 'openid profile email',
            ...authOptions,
        });
        // Store clientID to use with logout
        this.clientId = authOptions.clientID;
        this.domain = authOptions.domain;
        // pre-populate loginHint with SP customer number if available
        this.populateLoginHintWithSPCookie();
        // if the user was previously authenticated,
        // populate the local session
        if (this.isAuthenticated()) {
            try {
                await this.checkSession();
            }
            catch (err) {
                console.error(err);
            }
        }
        return this;
    }
    crossOriginVerification() {
        this.providerInstance.crossOriginVerification();
    }
    /**
     * Kicks off the login process (for username-password).  Upon success, browser will be redirected
     * to the configured redirectUri in the AuthOptions.
     * @param username
     * @param password
     */
    login(username, password, errorCallback) {
        this.providerInstance.login({
            password,
            realm: 'Username-Password-Authentication',
            username,
        }, errorCallback);
    }
    /**
     * Authorizes the user using the provided authorization options
     * @param options
     */
    authorize(options) {
        this.providerInstance.authorize(options);
    }
    /**
     * Logs the user out of their session
     * @param returnTo
     */
    logout(returnTo) {
        const pastTime = new Date();
        // Expire cookies
        pastTime.setTime(pastTime.getTime() - 1000 * 60 * 60 * 24);
        TokenManager.setCookie(LOGIN_HINT_COOKIE, `;expires=${pastTime.toUTCString()}`);
        TokenManager.setCookie(EXPIRES_AT_COOKIE, `;expires=${pastTime.toUTCString()}`);
        TokenManager.setCookie(AUTH0_SESSION_ACTIVE, `;expires=${pastTime.toUTCString()}`);
        // clear in-memory session
        this.profile = null;
        this.accessToken = '';
        sessionStorage.removeItem('mlpBearerToken');
        // Invalidate previous access and id tokens
        this.providerInstance.logout({ clientID: this.clientId, returnTo });
        // clear renew schedule
        clearTimeout(this.schedulerId);
    }
    /**
     * Parses the url hash after authentication to store tokens and user profile
     * @param options
     */
    handleAuthentication(options = {}) {
        options.__enableIdPInitiatedLogin = true;
        return new Promise((resolve, reject) => {
            this.providerInstance.parseHash(options, async (err, authResult) => {
                if (authResult && authResult.accessToken && authResult.idToken) {
                    try {
                        jwt_decode(authResult.accessToken);
                        this.setSession(authResult);
                        resolve(authResult);
                    }
                    catch (_) {
                        // Need to checkSession when opaque token is received via
                        // IDP initiated SSO
                        const result = await this.renewToken();
                        resolve(result);
                    }
                }
                else {
                    console.error(err);
                    reject(err);
                }
            });
        });
    }
    /**
     * Indicates whether or not there is an authenticated user
     */
    isAuthenticated() {
        const auth0SessionCookie = TokenManager.getCookie(AUTH0_SESSION_ACTIVE);
        const expiresAtCookie = TokenManager.getCookie(EXPIRES_AT_COOKIE);
        if (!!auth0SessionCookie && expiresAtCookie) {
            const expiresAt = JSON.parse(expiresAtCookie);
            return new Date().getTime() < expiresAt;
        }
        return false;
    }
    /**
     * Returns the active user's profile
     */
    getProfile() {
        return new Promise((resolve, reject) => {
            if (!!this.profile) {
                resolve(this.profile);
            }
            else {
                if (!this.accessToken) {
                    reject('User session must be loaded before accessing user profile');
                }
                else {
                    this.providerInstance.client.userInfo(this.accessToken, (err, user) => {
                        if (!!err) {
                            console.error(err);
                            reject(err);
                        }
                        else {
                            this.profile = user;
                            resolve(this.profile);
                        }
                    });
                }
            }
        });
    }
    /**
     * Callback to set the session after the mfa service verifies the mlp-mfa-session cookie.
     */
    setSessionCallback = (message) => {
        if (this.isMfaCallBack(message.data)) {
            const state = message.target.state;
            const nonce = message.target.nonce;
            const decodedJwt = jwt_decode(message.data.idToken);
            // @ts-ignore
            if (state === message.data.state && nonce === decodedJwt.nonce) {
                this.setSession(message.data);
            }
            else {
                console.error('state and nonce not good');
                throw Error('Error refreshing session for mfa.');
            }
        }
        else if (message.data === 'Error getting authorization tokens.') {
            this.logout(`https://${window.location.hostname}/customer/public/login`);
        }
    };
    /**
     * Check the mfa session by verifying the mlp-mfa-session cookie in the mfa-service.
     */
    checkSession() {
        const ipRegex = /^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/;
        if (window.location.pathname.indexOf('/customer/public') > -1 ||
            window.location.hostname.indexOf('localhost') > -1 ||
            ipRegex.test(window.location.hostname) || // IP for testing on VDI. Could improve by checking for private IPs.
            window.location.hostname.indexOf('mlp-admin-gateway-test.mlp-ext-test.aws.cloud.lfg.com') > -1 ||
            window.location.hostname.indexOf('mlp-admin-gateway.mlp.aws.cloud.lfg.com') > -1 ||
            window.location.hostname.indexOf('admin.np-mylincolnportal.com') > -1 ||
            window.location.hostname.indexOf('admin.mylincolnportal.com') > -1) {
            return this.renewToken();
        }
        return new Promise((resolve) => {
            this.cleanupMfaIframe();
            const state = TokenManager.generateRandomString();
            const nonce = TokenManager.generateRandomString();
            const iframe = document.createElement('iframe');
            const loginHint = TokenManager.getCookie(LOGIN_HINT_COOKIE);
            let url;
            //throws error if loginHint is invalid
            if (loginHint != null && TokenManager.isValidId(loginHint)) {
                url =
                    `https://${window.location.hostname}/mfa-service/check-session` +
                        `?state=${state}&nonce=${nonce}&login_hint=${loginHint}&domain=${this.domain}`;
            }
            else {
                url =
                    `https://${window.location.hostname}/mfa-service/check-session` +
                        `?state=${state}&nonce=${nonce}&domain=${this.domain}`;
            }
            iframe.src = url;
            iframe.height = '0';
            iframe.width = '0';
            iframe.setAttribute('id', 'mfa');
            // @ts-ignore
            window.state = state;
            // @ts-ignore
            window.nonce = nonce;
            document.body.appendChild(iframe);
            window.addEventListener('message', (message) => {
                if (this.isMfaCallBack(message.data)) {
                    this.setSessionCallback(message);
                    resolve();
                }
            });
        });
    }
    /**
     * Sets the active loginHint
     * @param loginHint
     */
    setLoginHint(loginHint) {
        TokenManager.setCookie(LOGIN_HINT_COOKIE, loginHint);
    }
    /**
     * Gets an authorization header used to make authenticated requests
     */
    getAuthHeader() {
        return `Bearer ${this.accessToken}`;
    }
    /**
     * TODO: Should be public, but LCI is currently leveraging.
     */
    renewToken() {
        return new Promise((resolve, reject) => {
            this.providerInstance.checkSession({
                login_hint: TokenManager.getCookie(LOGIN_HINT_COOKIE),
            }, (err, result) => {
                if (err) {
                    console.error(err);
                    reject(err);
                }
                else {
                    this.setSession(result);
                    resolve(result);
                }
            });
        });
    }
    /**
     * Schedules the token set to be renewed 30 seconds prior to expiration
     */
    scheduleRenewal(expiresAt) {
        if (!this.isAuthenticated()) {
            console.error('Could not schedule renewal as user was never authenticated!');
        }
        else {
            clearTimeout(this.schedulerId);
            const refreshAt = expiresAt - 1000 * 30;
            const timeUntilExpiration = Math.max(1, refreshAt - Date.now());
            // @ts-ignore
            this.schedulerId = setTimeout(async () => {
                try {
                    await this.checkSession();
                }
                catch (e) {
                    console.error(e);
                }
            }, timeUntilExpiration);
        }
    }
    /**
     * Sets the active session in the browser/memory, and schedules the renewal of the token
     * @param authResult
     */
    setSession(authResult) {
        const { accessToken, expiresIn, idTokenPayload } = authResult;
        // Store state in memory/browser
        const expiresAt = expiresIn * 1000 + new Date().getTime();
        TokenManager.setCookie(EXPIRES_AT_COOKIE, JSON.stringify(expiresAt));
        TokenManager.setCookie(AUTH0_SESSION_ACTIVE, 'true');
        this.profile = idTokenPayload;
        this.accessToken = accessToken;
        sessionStorage.setItem('mlpBearerToken', accessToken);
        this.scheduleRenewal(expiresAt);
    }
    /**
     * Loads customer number (if available) off of the SharePoint cookie
     */
    populateLoginHintWithSPCookie() {
        const customerId = TokenManager.getCookie(CUSTOMER_ID_COOKIE);
        if (!!customerId) {
            this.setLoginHint(customerId);
        }
    }
    /**
     * Determines if the data is a callback from the mfa service.
     * @param data
     */
    isMfaCallBack(data) {
        return ('state' in data &&
            'idToken' in data &&
            'tokenType' in data &&
            'expiresIn' in data &&
            'accessToken' in data);
    }
    /**
     * Cleanup the iframe and data appended to the window.
     */
    cleanupMfaIframe() {
        // @ts-ignore
        window.state = undefined;
        // @ts-ignore
        window.nonce = undefined;
        const iframe = document.getElementById('mfa');
        const body = document.querySelector('body');
        if (!!iframe)
            body.removeChild(iframe);
        window.removeEventListener('message', this.setSessionCallback);
    }
}
// Create a "default" implementation using Auth0
// TODO - Remove this ts-ignore... we need to use an old version of @types/auth0-js,
// as our Angular core component is using TS 2.2.2 🤦🏻‍♂️
// @ts-ignore
const auth0TokenManager = new TokenManager(WebAuth);
export default auth0TokenManager;
